import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px' }}>
      
      <Card style={{ padding: '40px' }}>
        <Title level={1} style={{ textAlign: 'center', marginBottom: '40px' }}>
          Privacy Policy
        </Title>
        
        <Title level={3}>Effective Date: March 30, 2026</Title>
        
        <Paragraph>
          <Text strong>Pathmarkr</Text> ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our route-based advertising and fleet intelligence services.
        </Paragraph>

        <Title level={2}>1. Information We Collect</Title>
        
        <Title level={4}>Personal Information</Title>
        <Paragraph>
          We collect information you provide directly to us, including:
        </Paragraph>
        <ul>
          <li>Name, email address, and phone number</li>
          <li>Geotab account credentials (username, password, database)</li>
          <li>Billing and payment information</li>
          <li>Business information and vehicle fleet details</li>
        </ul>

        <Title level={4}>SMS Consent Information</Title>
        <Paragraph>
          When you provide your phone number and consent to SMS messaging, we record:
        </Paragraph>
        <ul>
          <li>Phone number and consent timestamp</li>
          <li>Opt-in method (web form, verbal, SMS START)</li>
          <li>Message delivery status and opt-out requests</li>
        </ul>

        <Title level={4}>Automatically Collected Information</Title>
        <Paragraph>
          We automatically collect technical information about your use of our services:
        </Paragraph>
        <ul>
          <li>GPS location data from vehicle tracking</li>
          <li>Usage patterns and service interactions</li>
          <li>Device information and IP address</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>

        <Title level={2}>2. How We Use Your Information</Title>
        <Paragraph>
          We use your information to:
        </Paragraph>
        <ul>
          <li>Provide and maintain our services</li>
          <li>Send SMS notifications for route updates, campaign alerts, and important service information</li>
          <li>Process payments and manage your account</li>
          <li>Analyze usage patterns to improve our services</li>
          <li>Comply with legal obligations</li>
        </ul>

        <Title level={2}>3. SMS Messaging</Title>
        <Paragraph>
          By providing your phone number and checking the SMS consent box, you agree to receive automated text messages from Pathmarkr. Message frequency varies based on your service usage and campaign activity.
        </Paragraph>
        
        <Paragraph>
          <Text strong>Message & Data Rates:</Text> Standard message and data rates may apply from your mobile carrier.
        </Paragraph>
        
        <Paragraph>
          <Text strong>Opt-Out:</Text> You can opt-out at any time by replying "STOP" to any message from us.
        </Paragraph>
        
        <Paragraph>
          <Text strong>Help:</Text> Reply "HELP" for assistance with our SMS services.
        </Paragraph>

        <Title level={2}>4. Information Sharing</Title>
        <Paragraph>
          <Text strong>We do not sell your phone number or personal information to third parties for their own marketing purposes.</Text>
        </Paragraph>
        
        <Paragraph>
          We may share your information only in the following circumstances:
        </Paragraph>
        <ul>
          <li>With service providers who help us operate our business (e.g., SMS providers, payment processors)</li>
          <li>With Geotab for fleet tracking integration (with your consent)</li>
          <li>When required by law or to protect our rights</li>
          <li>In connection with a business sale or merger</li>
        </ul>

        <Title level={2}>5. Data Security</Title>
        <Paragraph>
          We implement appropriate technical and organizational measures to protect your information, including encryption, access controls, and regular security audits. However, no method of transmission over the internet is 100% secure.
        </Paragraph>

        <Title level={2}>6. Your Rights</Title>
        <Paragraph>
          You have the right to:
        </Paragraph>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Delete your account and associated data</li>
          <li>Opt-out of SMS communications at any time</li>
          <li>Request a copy of your data (portability)</li>
        </ul>

        <Title level={2}>7. Children's Privacy</Title>
        <Paragraph>
          Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13.
        </Paragraph>

        <Title level={2}>8. Changes to This Policy</Title>
        <Paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Effective Date" above.
        </Paragraph>

        <Title level={2}>9. Contact Us</Title>
        <Paragraph>
          If you have questions about this Privacy Policy or want to exercise your rights, please contact us:
        </Paragraph>
        <ul>
          <li>Email: privacy@pathmarkr.com</li>
          <li>Phone: [Your Phone Number]</li>
          <li>Address: [Your Business Address]</li>
        </ul>

        <Paragraph style={{ marginTop: '40px', textAlign: 'center', color: '#666' }}>
          <Text italic>Last updated: March 30, 2026</Text>
        </Paragraph>
      </Card>
    </div>
  );
}

export default PrivacyPolicy;
